module.exports = __webpack_public_path__ + "media/images/feature-image-9dd21f67.png";